<app-layout>
  <app-voltar route="listagem/funcionario" />

  <div class="headerForm">
    <div class="title">
      <app-titulo>{{ title }}</app-titulo>
    </div>
    <div class="espacamento"></div>
  </div>

  <div class="forms">
    <form [formGroup]="form">
      <div class="formList">
        <app-input
          label="Nome Completo"
          name="NM_FUNC"
          formControlName="NM_FUNC"
          placeholder="Digite aqui"
          maxLength="50"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="CPF"
          name="TX_CPF_FUNC"
          formControlName="TX_CPF_FUNC"
          mask="000.000.000-00"
          placeholder="___.___.___-__"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          type="email"
          label="E-mail"
          name="TX_MAIL_FUNC"
          formControlName="TX_MAIL_FUNC"
          placeholder="exemplo@empresa.com.br"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Telefone"
          name="TX_TELE_FUNC"
          formControlName="TX_TELE_FUNC"
          mask="(00) 00000-0000"
          placeholder="(__) _____-____"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          label="Nome de usuário"
          name="TX_USER_NAME"
          formControlName="TX_USER_NAME"
          placeholder="Digite aqui"
          [requiredInput]="true"
          [disabled]="statusInput"></app-input>

        <app-input
          type="password"
          label="Senha"
          name="TX_SENH_FUNC"
          formControlName="TX_SENH_FUNC"
          maxLength="15"
          placeholder="Digite aqui"
          [requiredInput]="isCreateMode()"
          (ngModelChange)="confirmacaoSenha()"
          [disabled]="statusInput"></app-input>

        <app-input
          type="password"
          label="Confirme a senha"
          name="TX_SENH_FUNC_CNFRM"
          formControlName="TX_SENH_FUNC_CNFRM"
          maxLength="15"
          placeholder="Digite aqui"
          [requiredInput]="isCreateMode()"
          (ngModelChange)="confirmacaoSenha()"
          [disabled]="statusInput"></app-input>

        <div class="validators" *ngIf="(form.controls['TX_SENH_FUNC'].value || '').length > 0">
          <p [ngClass]="{ valid: isLengthValid, invalid: !isLengthValid }">No mínimo 8 caracteres</p>
          <p [ngClass]="{ valid: hasNumber, invalid: !hasNumber }">Pelo menos um número</p>
          <p [ngClass]="{ valid: hasLowercase, invalid: !hasLowercase }">No mínimo 1 caractere minúsculo</p>
          <p [ngClass]="{ valid: hasUppercase, invalid: !hasUppercase }">No mínimo 1 caractere maiúsculo</p>
          <p [ngClass]="{ valid: hasSpecialChar, invalid: !hasSpecialChar }">No mínimo 1 caractere especial</p>
          <p [ngClass]="{ valid: passwordsMatch, invalid: !passwordsMatch }">As senhas devem ser iguais</p>
        </div>
      </div>

      <app-botao
        *ngIf="!title.includes('Visualizar')"
        class="botao-cadastro"
        type="cadastro"
        [text]="isCreateMode() ? 'Cadastrar Funcionário' : 'Editar Funcionário'"
        (click)="postarDados()"
        [disabled]="!form.valid"></app-botao>
    </form>
  </div>

  <app-loader [isLoading]="isLoading"></app-loader>
</app-layout>
